import React from 'react';
import PropTypes from 'prop-types';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import { GatsbyImagePropType } from '../../../../services/proptypes';
import Image from '../../../../atoms/Image';

const propTypes = {
  title: PropTypes.string,
  src: PropTypes.oneOfType([PropTypes.string, GatsbyImagePropType]),
  position: PropTypes.oneOf(['right', 'left']),
};

const defaultProps = {
  title: null,
  src: null,
  position: null,
};

function Logo({ title, src, position, ...imageProps }) {
  if (!title && !src) {
    return null;
  }

  let content = title;

  if (src) {
    content = <Image {...imageProps} src={src} />;
  }

  return (
    <SemanticUIMenu.Item className="site-navigation-logo" header position={position}>
      {content}
    </SemanticUIMenu.Item>
  );
}

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
